import { CCard, CCardBody, CCardHeader } from '@coreui/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './carbonEmissionCard.module.scss'

const CarbonEmissionCard = ({ emissionStats }) => {
  const { t } = useTranslation()

  const emissionCardStats = [
    {
      title: t('reports.carbonEmissions.card.unitsDelivered'),
      field: 'units',
    },
    {
      title: t('reports.carbonEmissions.card.emissionPerUnit'),
      field: 'carbonEmittedPerUnit',
      unit: 'kg',
    },
  ]

  const carbonEmissionsProduct = (productUnits, unitEmissions) => {
    const units = productUnits ? Number(productUnits) : 0
    const unitEmission = unitEmissions ? Number(unitEmissions) : 0
    const productResult = units * unitEmission
    const resultTotal = productResult / 1000
    return resultTotal.toFixed(1)
  }

  const returnFormatValue = (inputValue) => {
    const value = inputValue ? Number(inputValue) : 0
    return value.toFixed(1)
  }

  const renderCardStats = () => (
    <>
      {emissionCardStats.map(({ title, field, unit }) => (
        <div key={title} className={styles.cardBodyContentDivStyle}>
          <div className={styles.cardEntryTitle}>{title}</div>
          <div className={styles.cardEntryValueDiv}>
            <div className={styles.cardEntryValue}>{returnFormatValue(emissionStats[field])}</div>
            <div className={styles.cardEntryValueUnit}>{unit}</div>
          </div>
        </div>
      ))}
      <div className={styles.cardBodyContentDivStyle}>
        <div className={styles.cardEntryTitle}>{t('reports.carbonEmissions.card.totalScope3')}</div>
        <div className={styles.cardEntryValueDiv}>
          <div className={styles.cardEntryValue}>
            {carbonEmissionsProduct(emissionStats?.units, emissionStats?.carbonEmittedPerUnit)}
          </div>
          <div className={styles.cardEntryValueUnit}>t</div>
        </div>
      </div>
    </>
  )

  return (
    <CCard className={styles.cardStyle}>
      <CCardHeader className={styles.cardHeaderPadding}>
        <div className={styles.cardHeaderTextStyle}>
          {t('reports.carbonEmissions.card.co2emissions')} <div className={styles.cardHeaderDot} />
          {emissionStats.year}
        </div>
      </CCardHeader>
      <CCardBody className={styles.cardBodyPadding}>{renderCardStats()}</CCardBody>
    </CCard>
  )
}

CarbonEmissionCard.defaultProps = {
  emissionStats: {
    year: 0,
    units: 0,
    carbonEmittedPerUnit: 0,
  },
}

CarbonEmissionCard.propTypes = {
  emissionStats: PropTypes.shape({
    year: PropTypes.number,
    units: PropTypes.number,
    carbonEmittedPerUnit: PropTypes.number,
  }),
}

export default CarbonEmissionCard
